import React from 'react';
import { CustomerDetails } from '../invoices.model';
import DateUtils from 'utils/dateUtils';

interface CustomerAdditionalInfoWidgetProps {
  customerData: CustomerDetails;
}

const CustomerAdditionalInfoWidget: React.FC<CustomerAdditionalInfoWidgetProps> = ({ customerData }) => {
  const additionalInfo = [
    {
      id: 'customer-side-panel-created-on',
      title: 'Created on',
      data: customerData?.createdAt
        ? DateUtils.getDateInFormat({
            date: new Date(customerData?.createdAt),
            dateFormat: 'dd MMM yyyy'
          })
        : ''
    },
    {
      id: 'customer-side-panel-created-by',
      title: 'Created by',
      data: customerData?.createdBy
    }
  ];

  return customerData ? (
    <div className="mx-4 rounded-md border border-border px-4 py-3">
      <div className="mb-3 text-sbase font-semibold leading-[18px] tracking-[-0.3px] text-primaryText">
        Additional Info
      </div>
      <div className="flex flex-col gap-4">
        {additionalInfo.map((info, index) => (
          <div
            className="flex justify-between text-sbase font-semibold leading-[18px] tracking-[-0.3px]"
            key={info.title + index}>
            <div className="text-accentText">{info.title}</div>
            <div className="text-tertiaryText">{info.data || '-'}</div>
          </div>
        ))}
      </div>
    </div>
  ) : (
    <></>
  );
};

export default CustomerAdditionalInfoWidget;
